import React from "react";

export const OneInTen: React.FC = () => {
  return (
    <div id="oneinten" className="oneinten-section">
      <div className="oneinten-row">
        {/* Left Column - Image with Text Overlay */}
        <div className="oneinten-image-container">
          <img 
            src="img/img3.webp" 
            alt="Endometriosis" 
            className="oneinten-image"
          />
          <div className="oneinten-image-overlay">
            <p className="oneinten-image-text">
              LA ENDOMETRIOSIS ES UNA DE LAS VEINTE ENFERMEDADES MÁS DOLOROSAS.
            </p>
          </div>
        </div>

        {/* Right Column - Statistics */}
        <div className="oneinten-stats-container">
          <div className="oneinten-stats-content">
            {/* Stat 1 */}
            <div className="oneinten-stat">
              <p className="oneinten-stat-label">AFECTA AL MENOS</p>
              <h2 className="oneinten-stat-number">1 EN 10</h2>
              <p className="oneinten-stat-label">PERSONAS</p>
            </div>

            {/* Stat 2 */}
            <div className="oneinten-stat">
              <h2 className="oneinten-stat-number">10 AÑOS</h2>
              <p className="oneinten-stat-label">DE DEMORA EN EL <strong>DIAGNÓSTICO</strong></p>
            </div>

            {/* Stat 3 */}
            <div className="oneinten-stat">
              <p className="oneinten-stat-label">AL DIA DE HOY</p>
              <h2 className="oneinten-stat-number">NO HAY CURA</h2>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
};

